/* global axios */
import ApiClient from './ApiClient';

class BillingPlanApi extends ApiClient {
  constructor() {
    super('billing/plan', { accountScoped: true });
  }

  update(planId) {
    return axios.patch(this.url, { plan_id: planId });
  }

  sync() {
    return axios.post(`${this.url}/sync`);
  }
}

export default new BillingPlanApi();
